module.exports = __webpack_public_path__ + "img/right.0d3b6e14.svg";